export class FicheCycle {  // FicheCycle
  Ident: string;
  NumstPRO: string;
  ProduPRO: string;
  Info_PRO: string;
  datedPRO: Date;
  DatedPro: string;
  datefPRO: Date;
  DatefPro: string;
  TypsoPRO: string;
  VillePRO: string;
  RegioPRO: string;
  Zone_PRO: string;
  PartiPRO: string;
  PrestPRO: string;
  PreRePRO: string;
  ProgrPRO: string;
  DureePRO: string;
  year: number;
  month: number;
  PjextPRO: string;
  DetailsFileName: string;
}
